"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (prefixedValue, value, keepUnprefixed) {
  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
};

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ../~/inline-style-prefixer/lib/utils/getPrefixedValue.js
 ** module id = 733
 ** module chunks = 2
 **/